import useNavigationStore from "@src/stores/navigationStore";
import AccountInformations from "./AccountInformations";
import AccountOptions from "./AccountOptions";
import PriceList from "./PriceList";
import FundsOrigin from "./FundsOrigin";
import Iban from "./Iban";

const componentMap = {
    AccountInformations: AccountInformations,
    AccountOptions: AccountOptions,
    PriceList: PriceList,
    FundsOrigin: FundsOrigin,
    Iban: Iban
};

export default function FifthSection() {
    const { section } = useNavigationStore();

    const SelectedComponent = componentMap[section.block as keyof typeof componentMap] || null;

    return <>{SelectedComponent ? <SelectedComponent /> : null}</>;
}
